import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import './DueDate.css';
import * as actions from '../Actions';
import { fetchInitialData } from "../../fetchData";
import Right from '../../right/Right';
import Service from '../../service/Service';
import withContext from "../../../withContext";

const service = new Service();

class DuedateDisclaimer extends Component {
    constructor(props) {
        super(props);

        this.state = {

            loggedin: false,
            IsExpected: false

        }
    }

    render() {
        return (
            <main className="main-container">
                <Helmet
                    title="Disclaimer | Due Date Calculator"
                    meta={[
                        { "name": "atdlayout", "content": "tools_sp" }
                    ]}
                />
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><a href={service.getRedirectUrl("/")} className="R11_9e">Home</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><a href={service.getRedirectUrl("/tools")} className="R11_9e">Tools</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>Due Date Calculator</span>
                    </div>
                    <h1 className="B24_00" id="skipToH1" tabIndex={0}>Disclaimer | Due Date Calculator</h1>
                </div>
                <div className="sub-container left">
                    <div className="data-container left">
                        <div className="duedate-container">
                            {/* <!-- duedate disclaimer code starts here -->   */}
                            <div className="duedate-disclaimer">
                                <div className="disclaimer-title">
                                    <h3>
                                        <span className="M17_42">Disclaimer :</span>
                                    </h3>
                                </div>
                                <div className="disclaimer-content">
                                    <span className="R14_61"> Firstcry Parenting - Due Date Calculator determines the probable due date. Only your physician/Doctor can accurately determine your due date based on his/her knowledge of your medical history. All the calculations are tentative and Firstcry won’t be responsible for any related consequences.
                            </span>
                                </div>
                                <div className="disclaimer-title">
                                    <h3>
                                        <span className="M17_42">Reference :</span>
                                    </h3>
                                </div>
                                <div className="disclaimer-content">
                                    <span className="R14_61">
                                        <a href="http://www.yourduedate.com/">
                                            http://www.yourduedate.com/
                                        </a>
                                        <a href="https://www.countdowntopregnancy.com/tools/due-date-calculator.php">
                                            https://www.countdowntopregnancy.com/tools/due-date-calculator.php
                                        </a>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Right url={this.props.location.pathname} />
            </main>
        )
    }
}

export default withContext(DuedateDisclaimer);